export const REVIEWS_TAB_TITLE = 'Reviews'
export const OVERVIEW_TAB = 0
export const REVIEWS_TAB = 1

export const FEATURES = 'Tire Line features'
export const BENEFITS = 'Benefits'
export const WARRANTY = 'Warranty'
